var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.746,
    height: 14.217,
    viewBox: "0 0 22.746 14.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "isActive",
    d: "M100.026,116.648c-2.508-2.931-7.055-7.108-11.373-7.108s-8.864,4.177-11.373,7.108c2.508,2.931,7.055,7.108,11.373,7.108S97.517,119.58,100.026,116.648Zm-11.373-4.024a4.024,4.024,0,1,1-4.024,4.024A4.024,4.024,0,0,1,88.653,112.624Zm0-1.024a5.048,5.048,0,1,1-5.048,5.048A5.048,5.048,0,0,1,88.653,111.6Z",
    transform: "translate(-77.28 -109.54)",
    fill: "rgba(0,0,0,0.4)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsActive);
export default __webpack_public_path__ + "static/media/isActive.99c24ff11feb859fdfce165cc4c8351c.svg";
export { ForwardRef as ReactComponent };